module.exports = require("live/components/forms/ui/table-form");